import React, { useState } from "react";
import { AppBar, Toolbar, Typography, IconButton, Menu, MenuItem } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import { useTranslation } from "react-i18next";
import logo from "assets/logos/Logo_Resiliage_MainLogo_Green.png"
import SideDrawer from "./Drawer";
import "./Header.css";
import { Chip, Tooltip, Box } from "@mui/material";
import SmartToyIcon from "@mui/icons-material/SmartToy";

const drawerItems = [
  { icon: "🏠", text: "Home", link: "/" },
  { icon: "🧙‍♂️", text: "Wizard", link: "/wizard" },
  { icon: "💡", text: "Solutions", link: "/solutions" },
  { icon: "📚", text: "Resources", link: "/resources" },
];

const Header = ({ drawerOpen: controlledOpen, setDrawerOpen: controlledSetOpen }) => {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  // Fallback to internal state if not controlled by parent
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
  const open = typeof controlledOpen === "boolean" ? controlledOpen : uncontrolledOpen;
  const setOpen = typeof controlledSetOpen === "function" ? controlledSetOpen : setUncontrolledOpen;

  const handleOpenMenu = (e) => setAnchorEl(e.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);
  const changeLanguage = (lng) => { i18n.changeLanguage(lng); handleCloseMenu(); };
  const toggleDrawer = () => setOpen(!open);
  const isAiTranslation = i18n.language && i18n.language !== "en";

  return (
    <>
      <AppBar
        position="fixed"
        className="header"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          marginLeft: open ? "240px" : "60px",
          width: open ? "calc(100% - 240px)" : "calc(100% - 60px)",
          transition: "width 0.3s ease, margin 0.3s ease",
          "@media (max-width: 768px)": { marginLeft: 0, width: "100%" },
        }}
      >
        <Toolbar className="toolbar">
          <div className="logoTitleContainer">
            <img src={logo} alt="Logo" className="logo" />
            <Typography variant="h6" className="headerTitle">Decision Support System</Typography>
          </div>



          <Box
            className="headerButtonContainer"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            {/* tooltip for AI tag */}
            {isAiTranslation && (
              <Tooltip
                title={
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <SmartToyIcon sx={{ fontSize: 18, color: "#0fe880", mt: "2px" }} />
                    <Typography
                      sx={{
                        fontSize: "0.85rem",
                        lineHeight: 1.4,
                      }}
                    >
                      {t("header.aiTranslation.tooltip")}
                    </Typography>
                  </Box>
                }
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#ffffff",
                      color: "#000",
                      border: "1px solid rgba(0,0,0,0.15)",
                      borderLeft: "4px solid #0fe880",
                      boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                      padding: "10px 12px",
                      maxWidth: 260,
                    },
                  },
                  arrow: {
                    sx: {
                      color: "#ffffff",
                    },
                  },
                }}
              >
                {/* this triggers the tooltip and u get the text */}
                <Chip
                  className="aiTranslationChip"
                  icon={<SmartToyIcon />}
                  label={t("header.aiTranslation.label")}
                  size="small"
                  sx={{
                    bgcolor: "transparent",        // 👈 achtergrond transparant
                    border: "1px solid transparent",
                    color: "#3B3B3B",              // tekstkleur
                    '& .MuiChip-icon': {
                      color: "#3B3B3B",            // icon kleur
                    },
                  }}
                />
              </Tooltip>
            )}

            <IconButton
              onClick={handleOpenMenu}
              color="other"
              className="headerButton"
              aria-controls="language-menu"
              aria-haspopup="true"
            >
              <LanguageIcon />
            </IconButton>
            <Menu id="language-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
              <MenuItem onClick={() => changeLanguage("en")}>English</MenuItem>
              <MenuItem onClick={() => changeLanguage("fr")}>Français</MenuItem>
              <MenuItem onClick={() => changeLanguage("es")}>Español</MenuItem>
              <MenuItem onClick={() => changeLanguage("el")}>Ελληνικά</MenuItem>
              {/* <MenuItem onClick={() => changeLanguage("pt")}>Português</MenuItem>
              <MenuItem onClick={() => changeLanguage("tr")}>Türkçe</MenuItem> */}
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      <SideDrawer open={open} onToggle={toggleDrawer} items={drawerItems} />
    </>
  );
};

export default Header;
